import { POLITICS } from 'constants/links';

const { DEFAULT, MIRROR } = POLITICS;

export const LINKS = [
    {
        title: 'Privacy Policy',
        links: [MIRROR.PRIVACY_POLICY, DEFAULT.PRIVACY_POLICY] as const,
        dataLocator: 'privacyPolicyLink',
    },
    {
        title: 'Terms of Use',
        links: [MIRROR.TERMS_OF_USE, DEFAULT.TERMS_OF_USE] as const,
        dataLocator: 'termsOfUseLink',
    },
    {
        title: 'Refund Policy',
        links: [MIRROR.REFUND_POLICY, DEFAULT.REFUND_POLICY] as const,
        dataLocator: 'refundPolicyLink',
    },
];
